import type {IconColorVariant} from './types';

type Props = {
  readonly variant?: IconColorVariant;
} & React.ComponentPropsWithRef<'svg'>;

function CloseCircleIcon({variant = 'colored', ...props}: Props): JSX.Element {
  let circleColor = '#3879B7';
  let vectorColor = '#FFFFFF';
  if (variant === 'white') {
    circleColor = '#FFFFFF';
    vectorColor = '#959595';
  } else if (variant === 'gray') {
    circleColor = '#959595';
  }

  return (
    <svg
      data-testid='close-icon'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <path
        d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z'
        fill={circleColor}
      />
      <path
        d='M15.4978 17L7 8.50221L8.50221 7L17 15.4978L15.4978 17Z'
        fill={vectorColor}
      />
      <path
        d='M8.50221 17L17 8.50221L15.4978 7L7 15.4978L8.50221 17Z'
        fill={vectorColor}
      />
    </svg>
  );
}

export default CloseCircleIcon;
